function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import StoreFilters from "./storeFilters.class";
import { Constants as CONSTANTS } from "./constants.class";
import Tracking from "./tracking.class";
var SelectedFilters = /*#__PURE__*/function (_StoreFilters) {
  function SelectedFilters(config) {
    var _this;
    _classCallCheck(this, SelectedFilters);
    _this = _callSuper(this, SelectedFilters, [config]);
    try {
      if (config.event === undefined || config.event === null) throw new Error("CLass SelectedFilters need event in parameters");
      _this.selectedFiltersElts = document.querySelectorAll(".".concat(CONSTANTS.SELECTED_FILTERS.DELETE_SELECTOR));
      _this.selectedFilters = {};
      _this.resetButton = null;
      _initEvents.call(_this);
      _getSelectedFiltersValues.call(_this);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Error class SelectedFilters", err);
    }
    return _this;
  }
  _inherits(SelectedFilters, _StoreFilters);
  return _createClass(SelectedFilters);
}(StoreFilters);
export default SelectedFilters;

/**
 * get all values of selected filters
 * @private
 */

function _getSelectedFiltersValues() {
  if (this.selectedFiltersElts.length > 0) {
    this.selectedFilters = Array.from(this.selectedFiltersElts).reduce(function (values, value) {
      var _value$parentElement$ = value.parentElement.dataset,
        filterValue = _value$parentElement$.filterValue,
        filterCode = _value$parentElement$.filterCode,
        filterType = _value$parentElement$.filterType;
      if (values[filterCode] === undefined) {
        values[filterCode] = [];
      }
      if (filterType === CONSTANTS.FILTERS_TYPES.RANGE) {
        values[filterCode] = filterValue;
      } else {
        values[filterCode].push(filterValue);
      }
      return values;
    }, {});
  }
}

/**
 * inti all of event of composant selected filters (tags and reset button)
 * @private
 */
function _initEvents() {
  var _this2 = this;
  if (this.selectedFiltersElts.length > 0) {
    //init delete buttons events
    this.selectedFilters = Array.from(this.selectedFiltersElts);
    this.selectedFilters.forEach(function (_button) {
      return _button.addEventListener("click", _deleteFilter.bind(_this2));
    });
    // init reset button event
    this.resetButton = document.querySelector(".".concat(CONSTANTS.SELECTED_FILTERS.RESET_SELECTOR));
    this.resetButton.addEventListener("click", _resetFilters.bind(this));
  }
}

/**
 * delete one clicked filter and dispatch event
 * @param evt
 * @private
 */
function _deleteFilter(evt) {
  var _evt$target$parentEle = evt.target.parentElement.dataset,
    filterValue = _evt$target$parentEle.filterValue,
    filterType = _evt$target$parentEle.filterType,
    filterCode = _evt$target$parentEle.filterCode;
  if (filterType === CONSTANTS.FILTERS_TYPES.STANDARD || filterType === CONSTANTS.FILTERS_TYPES.IMAGE || filterType === CONSTANTS.FILTERS_TYPES.TOGGLE || filterType === CONSTANTS.FILTERS_TYPES.HIERARCHICAL || filterType === CONSTANTS.FILTERS_TYPES.COLOR || filterType === CONSTANTS.FILTERS_TYPES.VENDOR || filterType === CONSTANTS.FILTERS_TYPES.REVIEW) {
    var _iterator = _createForOfIteratorHelper(this.selectedFilters[filterCode]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        if (value === filterValue) {
          var index = this.selectedFilters[filterCode].indexOf(value);
          this.selectedFilters[filterCode].splice(index, 1);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (this.selectedFilters[filterCode].length === 0) {
      delete this.selectedFilters[filterCode];
    }
  }
  if (filterType === CONSTANTS.FILTERS_TYPES.RANGE) {
    delete this.selectedFilters["".concat(filterCode)];
  }
  this.dispatch({
    action: "filter",
    params: {
      lastSelectedFilter: filterCode
    },
    filters: this.format(this.selectedFilters)
  });
  new Tracking({
    event: evt,
    type: "filter"
  });
}

/**
 * reset and delete all filters values
 * @private
 */
function _resetFilters(evt) {
  evt.preventDefault();
  this.selectedFilters = {};
  var params = new URLSearchParams(window.location.search);
  params["delete"]("filters");
  window.history.pushState({}, window.tc_vars.page_name, "".concat(window.location.pathname, "?").concat(params.toString()));
  this.dispatch({
    action: "filter",
    filters: this.format(this.selectedFilters)
  });
}